import { render, staticRenderFns } from "./le-button.vue?vue&type=template&id=e72b1566&scoped=true&"
import script from "./le-button.vue?vue&type=script&lang=js&"
export * from "./le-button.vue?vue&type=script&lang=js&"
import style0 from "./le-button.vue?vue&type=style&index=0&id=e72b1566&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72b1566",
  null
  
)

export default component.exports